import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import React from 'react';
import useAuthToken from '../../../hooks/getUserData';
import AddVideoLinks from './AddVideoLinks';

const YoutubeVideos = ({
  product,
  fetchProduct,
  setMessage,
  setSnackbarOpen,
}) => {
  const token = useAuthToken();

  return (
    <Card>
      <CardHeader
        title="Product videos"
        action={
          <AddVideoLinks
            product={product}
            fetchData={fetchProduct}
            token={token}
            setMessage={setMessage}
            setSnackbarOpen={setSnackbarOpen}
          />
        }
      />
      <CardContent>
        {product?.youtube_links?.length > 0 ? (
          <Grid container spacing={2}>
            {product?.youtube_links.map((link, index) => (
              <Grid item key={index} xs={12}>
                <Typography>
                  Video {index + 1}:{' '}
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}>
                    {link}
                  </a>
                </Typography>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography
            sx={{ textAlign: 'center' }}
            variant="caption"
            component="p">
            You can add video links here
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default YoutubeVideos;
